module.exports = __webpack_public_path__ + "media/honey-icons/icon-group-42f37afc.svg";